var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "body" },
    [
      _c("service-tabbar", { attrs: { current: "1" } }),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "left-tab-warp" }, [_c("left-tab")], 1),
        _c("div", { staticClass: "right-wrap" }, [
          _c("div", { staticClass: "right-content" }, [
            _c("div", { staticClass: "right-toolbar" }, [
              _c("h2", { staticClass: "title" }, [_vm._v("广仲案件")]),
              _c(
                "div",
                { staticClass: "right" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function($event) {
                          return _vm.toConsumeList()
                        }
                      }
                    },
                    [_vm._v("消费记录")]
                  )
                ],
                1
              )
            ]),
            _c(
              "div",
              { staticClass: "table-warp" },
              [
                _c(
                  "el-row",
                  {
                    staticClass: "row",
                    staticStyle: { margin: "0" },
                    attrs: { gutter: 20 }
                  },
                  [
                    _c("el-col", { attrs: { span: 2 } }, [
                      _c(
                        "p",
                        {
                          staticStyle: {
                            "line-height": "34px",
                            "font-weight": "600"
                          }
                        },
                        [_vm._v("关键字")]
                      )
                    ]),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _c("el-input", {
                          attrs: { size: "small", placeholder: "申请人" },
                          model: {
                            value: _vm.claimantName,
                            callback: function($$v) {
                              _vm.claimantName = $$v
                            },
                            expression: "claimantName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _c("el-input", {
                          attrs: { size: "small", placeholder: "被申请人" },
                          model: {
                            value: _vm.respondentName,
                            callback: function($$v) {
                              _vm.respondentName = $$v
                            },
                            expression: "respondentName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _c("el-input", {
                          attrs: { size: "small", placeholder: "案件号" },
                          model: {
                            value: _vm.caseNo,
                            callback: function($$v) {
                              _vm.caseNo = $$v
                            },
                            expression: "caseNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择状态", size: "small" },
                            model: {
                              value: _vm.caseStatus,
                              callback: function($$v) {
                                _vm.caseStatus = $$v
                              },
                              expression: "caseStatus"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "全部", value: "" }
                            }),
                            _c("el-option", {
                              attrs: { label: "待提交", value: 0 }
                            }),
                            _c("el-option", {
                              attrs: { label: "审理中", value: 1 }
                            }),
                            _c("el-option", {
                              attrs: { label: "待缴费", value: 2 }
                            }),
                            _c("el-option", {
                              attrs: { label: "已立案", value: 3 }
                            }),
                            _c("el-option", {
                              attrs: { label: "已提交", value: 4 }
                            }),
                            _c("el-option", {
                              attrs: { label: "预审通过", value: 5 }
                            }),
                            _c("el-option", {
                              attrs: { label: "已缴费", value: 6 }
                            }),
                            _c("el-option", {
                              attrs: { label: "已结案", value: 7 }
                            }),
                            _c("el-option", {
                              attrs: { label: "撤回申请", value: 8 }
                            }),
                            _c("el-option", {
                              attrs: { label: "不受理", value: 9 }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { staticClass: "search-btn-warp", attrs: { span: 6 } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: { click: _vm.buttonQuery }
                          },
                          [_vm._v("查询")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ],
                    staticClass: "data-list",
                    style: { "min-height": _vm.tableHeight + "px" },
                    attrs: {
                      data: _vm.listData,
                      "tooltip-effect": "dark",
                      "header-cell-style": {
                        background: "#f9f9f9",
                        color: "#333333",
                        fontWeight: "500"
                      }
                    },
                    on: { "selection-change": _vm.handleSelectionChange }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { type: "selection", width: "55" }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "案件号",
                        prop: "orderNumber",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "证书编号",
                        prop: "pid",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _c("el-table-column", {
                      attrs: { label: "申请人", "show-overflow-tooltip": "" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n                " +
                                  _vm._s(scope.row.claimantName || "--") +
                                  "\n              "
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: { label: "被申请人", "show-overflow-tooltip": "" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n                " +
                                  _vm._s(scope.row.respondentName || "--") +
                                  "\n              "
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: { label: "发布时间", "show-overflow-tooltip": "" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatDateTime")(scope.row.createTime)
                                )
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "状态",
                        prop: "stateStr",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作", width: "100" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.state == 0
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "color-success pointer",
                                      on: {
                                        click: function($event) {
                                          return _vm.toFillInfo(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("案件处理")]
                                  )
                                : scope.row.state == 3 && scope.row.arbcaseId
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "color-success pointer",
                                      on: {
                                        click: function($event) {
                                          return _vm.revoke(scope.row.arbcaseId)
                                        }
                                      }
                                    },
                                    [_vm._v("撤销案件")]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _c(
                      "div",
                      {
                        staticClass: "com-custom-nodata",
                        attrs: { slot: "empty" },
                        slot: "empty"
                      },
                      [
                        _c("div", { staticClass: "bx" }, [
                          _c("h1", [_vm._v("时间短·费用低·支持批量")]),
                          _c("p", [
                            _c("span", { staticClass: "rd" }, [
                              _vm._v(
                                "联合仲裁委共同推出，文书自动生成，一键立案"
                              )
                            ]),
                            _c("span", { staticClass: "rd" }, [
                              _vm._v(
                                "智能判例匹配，异地服务协同，5~10天出裁决书"
                              )
                            ])
                          ]),
                          _c("p", [
                            _c("span", { staticClass: "rd" }, [
                              _vm._v("一裁终决，成本可降至传统诉讼的十分之一")
                            ])
                          ]),
                          _c("img", {
                            staticClass: "simg",
                            attrs: { src: "/images/web/nodata-zc.png" }
                          })
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm.listData && _vm.listData.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "pageation row page-flex-end",
                        staticStyle: { position: "relative" }
                      },
                      [
                        _vm.paged.total > 0
                          ? _c("el-pagination", {
                              attrs: {
                                "pager-count": 5,
                                total: _vm.paged.total,
                                "current-page": _vm.paged.pageNum,
                                "page-size": _vm.paged.pageSize,
                                "page-sizes": [10, 20, 50, 100],
                                layout: "sizes, prev, pager, next, total"
                              },
                              on: {
                                "size-change": _vm.handleSizeChange,
                                "current-change": _vm.handleCurrentChange,
                                "update:currentPage": function($event) {
                                  return _vm.$set(_vm.paged, "pageNum", $event)
                                },
                                "update:current-page": function($event) {
                                  return _vm.$set(_vm.paged, "pageNum", $event)
                                }
                              }
                            })
                          : _vm._e(),
                        _c("el-go", {
                          attrs: {
                            "page-size": _vm.paged.pageSize,
                            total: _vm.paged.total
                          },
                          on: { "current-change": _vm.handleCurrentChange }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ])
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showProgressDialog,
            title: "进度查询",
            width: "500px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.showProgressDialog = $event
            }
          }
        },
        [
          _c("div", { staticStyle: { "margin-top": "15px" } }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-8" }, [
                _c("h5", { staticClass: "list-title" }, [
                  _vm._v("\n            立案号："),
                  _c("span", { attrs: { name: "arbcaseId" } }, [
                    _vm._v(_vm._s(_vm.progressData.caseNo))
                  ])
                ])
              ])
            ]),
            _c(
              "ul",
              {
                staticClass: "list-step",
                staticStyle: { "margin-top": "30px", "margin-bottom": "30px" }
              },
              [
                _c(
                  "li",
                  {
                    class: {
                      active: _vm.progressData.caseState == 0,
                      finished: _vm.progressData.caseState > 0
                    }
                  },
                  [
                    _c("span", { staticClass: "step-item step-1" }, [
                      _c("img", {
                        attrs: { src: "/images/arbitation/step_1.png" }
                      })
                    ]),
                    _c("div", { staticClass: "word-keep" }, [_vm._v("申请中")])
                  ]
                ),
                _c(
                  "li",
                  {
                    class: {
                      finished: _vm.progressData.caseState > 0,
                      arrow: true
                    }
                  },
                  [_c("i", { staticClass: "el-icon-arrow-right" })]
                ),
                _c(
                  "li",
                  {
                    class: {
                      active: _vm.progressData.caseState == 1,
                      finished: _vm.progressData.caseState > 1
                    }
                  },
                  [
                    _c("span", { staticClass: "step-item step-2" }, [
                      _c("img", {
                        attrs: { src: "/images/arbitation/step_2.png" }
                      })
                    ]),
                    _c("div", { staticClass: "word-keep" }, [_vm._v("已立案")])
                  ]
                ),
                _c(
                  "li",
                  {
                    class: {
                      finished: _vm.progressData.caseState > 1,
                      arrow: true
                    }
                  },
                  [_c("i", { staticClass: "el-icon-arrow-right" })]
                ),
                _c(
                  "li",
                  {
                    class: {
                      active: _vm.progressData.caseState == 2,
                      finished: _vm.progressData.caseState > 2
                    }
                  },
                  [
                    _c("span", { staticClass: "step-item step-3" }, [
                      _c("img", {
                        attrs: { src: "/images/arbitation/step_3.png" }
                      })
                    ]),
                    _c("div", { staticClass: "word-keep" }, [_vm._v("审核中")])
                  ]
                ),
                _c(
                  "li",
                  {
                    class: {
                      finished: _vm.progressData.caseState > 2,
                      arrow: true
                    }
                  },
                  [_c("i", { staticClass: "el-icon-arrow-right" })]
                ),
                _c(
                  "li",
                  {
                    class: {
                      active: _vm.progressData.caseState == 3,
                      finished: _vm.progressData.caseState > 3
                    }
                  },
                  [
                    _c("span", { staticClass: "step-item step-4" }, [
                      _c("img", {
                        attrs: { src: "/images/arbitation/step_4.png" }
                      })
                    ]),
                    _c("div", { staticClass: "word-keep" }, [_vm._v("已结案")])
                  ]
                )
              ]
            )
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "danger" },
                  on: {
                    click: function($event) {
                      _vm.showProgressDialog = false
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ff68fdb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ff68fdb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/judicialService/arbitration.vue
// module id = GlIB
// module chunks = 81